module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.$slots.header) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Close\n            ")])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce93a634","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 628
// module chunks = 2